import { extend } from 'vee-validate';

extend('digits_between_1_100', {
  validate: (value) => {
    return value >= 1 && value <= 100;
  },
});
